import { createTrackingUtils } from "../index.js";
import useProfiler from "../../../hooks/useProfiler.js";
import { useEffect } from "react";
const utils = createTrackingUtils({
    name: "flights_funnel_sr_cards_redesign_mobile",
    stages: {
        direct: 2,
        meta: 3,
        families: 4,
        longHaul: 5,
        weekendTravellers: 6
    },
    goals: {
        bfCtaClick: 1
    },
    defaultStage: 1
});
const useTrackStages = () => {
    const { stages } = utils;
    const { isDirect, isMeta, isFamily, isLongHaul, isWeekendStay } = useProfiler();
    useEffect(() => {
        isDirect() && stages.direct();
        isMeta() && stages.meta();
        isFamily() && stages.families();
        isLongHaul() && stages.longHaul();
        isWeekendStay() && stages.weekendTravellers();
    }, [stages, isDirect, isMeta, isFamily, isLongHaul, isWeekendStay]);
};
export default { ...utils, useTrackStages };
